import React from "react";

import Hoc from "../../util/Hoc";

const cvItemDesc = props => {
  let itemDescBold;
  let itemDescNormal = null;
  if (props.descBold && props.descBold.trim() !== "") {
    itemDescBold = <span className="bold"> {props.descBold} </span>;
    if (props.descNormal) {
      itemDescNormal = <span> {" - " + props.descNormal} </span>;
    }
  } else {
    if (props.descNormal) {
      itemDescNormal = <span> {props.descNormal} </span>;
    }
  }

  let itemDescCooment = null;
  if (props.descComment) {
    itemDescCooment = <span className="bold">{" - " + props.descComment}</span>;
  }

  return (
    <Hoc>
      <div className="cv-item-desc">
        {itemDescBold}
        {itemDescNormal}
        {itemDescCooment}
      </div>
      {props.children ? <div className="cv-item__details">{props.children}</div> : null}
    </Hoc>
  );
};

cvItemDesc.defaultProps = {
  cvItemType: "Description"
};

export default cvItemDesc;
